module.exports = __webpack_public_path__ + "static/media/battle-logo.56c47683.svg";